const moment = require('moment');
/**
 * 単純なサンプル
 * moment.jsを使って現在日付をconsole出力するだけ
 */
$(function () {
	console.log(moment().format("YYYY-MM-DD"));

	$('.search select').change(function () {
		var speed = 400;
		var href = $(this).val();
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$('body,html').animate({
			scrollTop: position - $(".search").outerHeight()
		}, speed, 'swing');
		return false;
	});
});
